module.exports = __webpack_public_path__ + "static/media/shia-4.47aadd00.mp3";